import { render, staticRenderFns } from "./PowerupUpTermViewComponent.vue?vue&type=template&id=1b143462&scoped=true"
import script from "./PowerupUpTermViewComponent.vue?vue&type=script&lang=js"
export * from "./PowerupUpTermViewComponent.vue?vue&type=script&lang=js"
import style0 from "./PowerupUpTermViewComponent.vue?vue&type=style&index=0&id=1b143462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b143462",
  null
  
)

export default component.exports